export enum CsvHeadersIcp {
  SAMPLE_ID = 'Sample ID',
  ELEM = 'Elem',
  WAVELENGTH = 'Wavelength',
  CONC_SAMP = 'Conc (Samp)',
  CALIB_UNITS = 'Calib Units',
}
